// extracted by mini-css-extract-plugin
export var $animation_name = "RichText-module--$animation_name--8aa78";
export var Links = "RichText-module--Links--5936c";
export var RichText = "RichText-module--RichText--f097e";
export var RichText___christmas = "RichText-module--RichText___christmas--9910d";